import Icon from '../components/Icon.vue'

Icon.register({"bullhorn":{"width":1792,"height":1792,"paths":[{"d":"M1664 640q53 0 90.5 37.5t37.5 90.5-37.5 90.5-90.5 37.5v384q0 52-38 90t-90 38q-417-347-812-380-58 19-91 66t-31 100.5 40 92.5q-20 33-23 65.5t6 58 33.5 55 48 50 61.5 50.5q-29 58-111.5 83t-168.5 11.5-132-55.5q-7-23-29.5-87.5t-32-94.5-23-89-15-101 3.5-98.5 22-110.5h-122q-66 0-113-47t-47-113v-192q0-66 47-113t113-47h480q435 0 896-384 52 0 90 38t38 90v384zM1536 1244v-954q-394 302-768 343v270q377 42 768 341z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bullhorn.js
// module id = s5qK
// module chunks = 1